export default "__VITE_ASSET__kZygjhHn__"